import Env from "@env";

export function isDebugEnv(): boolean {
    let isDebug = false;

    // localhost names white list
    const localhostNames = [
        '127.0.0.1',
        'localhost', // dev
        'archipad.local', // Is this still used ??
        'cloud.archipad.dev', // stage
        'archipad-js-pr', // preview
    ];

    if(typeof window == "undefined") {
        return isDebug;
    }

    // check if the current hostname match one of the white list
    for (const localhostName of localhostNames) {
        if (window.location.host.startsWith(localhostName)) {
            isDebug = true;
            break;
        }
    }

    let query = window.location.search;
    if (query) {
        query = query.substring(1);
        const args = query.split('&');
        for (let i = 0; i < args.length; i++) {
            if (!args[i].indexOf('debug=')){
                isDebug = args[i].substring(6) == "true";
            }
        }
    }
    
    return isDebug;
}

/**
* [PLUS-158] Remove this function 
*/
export function isFeatureFlagsPlusAuthenticationServerEnable(): boolean {
    let isFeatureFlagsPlusAuthenticationServerEnable = Env["featureFlags"]?.['plusAuthenticationServer'];

    if( 
        typeof window == "undefined" ||
        typeof sessionStorage == "undefined"
    ) {
        return isFeatureFlagsPlusAuthenticationServerEnable;
    }

    const currentStorageValue: string | null = localStorage.getItem('auth');

    const params = new URLSearchParams(window.location.search);
    if (params) {
        const auth = params.get("auth");
        if(auth) {
            isFeatureFlagsPlusAuthenticationServerEnable = auth !== "legacy" // default to true if any other value than "legacy"
            localStorage.setItem("auth", auth);
            if(auth !== currentStorageValue) {
                location.reload();
            }
        }
    }

    if(currentStorageValue) {
        return currentStorageValue !== "legacy";
    }
    
    return isFeatureFlagsPlusAuthenticationServerEnable;
}


export function setFeatureFlagsPlusAuthenticationServer(value: boolean) {
    if( 
        typeof window == "undefined" ||
        typeof localStorage == "undefined"
    ) {
        return;
    }
    localStorage.setItem('auth', value ? "plus" : "legacy");
    location.reload();
}

export function getDebugSampleData(): SampleData {
    return {
        company: RANDOM_COMPANY,
        name: RANDOM_NAME,
        address: RANDOM_ADDRESS,
    };
}
export interface SampleData {
    company: string[];
    name: string[];
    address: string[];
}


const RANDOM_COMPANY = [
    "PANZENT",
    "MENBRAIN",
    "PERKLE",
    "GEEKWAGON",
    "SPRINGBEE",
    "GEEKOLOGY",
    "TERRAGEN",
    "BRAINCLIP",
    "CABLAM",
    "KENGEN",
    "BOSTONIC",
    "XTH",
    "VITRICOMP",
    "TUBALUM",
    "IMKAN",
    "ACCUPRINT",
    "GEOFARM",
    "COSMETEX",
    "ZENSURE",
    "SENTIA",
    "EXOSWITCH",
    "SECURIA",
    "MARKETOID",
    "RONELON",
    "GOLOGY",
    "EXIAND",
    "PYRAMIA",
    "SARASONIC",
    "BUZZNESS",
    "XURBAN",
    "PIGZART",
    "VOIPA",
    "DANJA",
    "XPLOR",
    "TERRAGO",
    "ZYTRAC",
    "DAISU",
    "EXOSPACE",
    "STROZEN",
    "CONFERIA",
    "STOCKPOST",
    "BALUBA",
    "ZOSIS",
    "DOGTOWN",
    "COMBOGENE",
    "OLUCORE",
    "COMVOY",
    "BULLZONE",
    "ZOLAR",
    "FUELTON",
    "EXERTA",
    "VIRXO",
    "JIMBIES",
    "PRINTSPAN",
    "COSMOSIS",
    "JOVIOLD",
    "OVIUM",
    "QNEKT",
    "PORTICA",
    "NUTRALAB",
    "COMVENE",
    "ELEMANTRA",
    "SPORTAN",
    "ECSTASIA",
    "EXTRAGENE",
    "ORBOID",
    "GRONK",
    "ZANYMAX",
    "ZERBINA",
    "RAMEON",
    "ISOTRACK",
    "TERSANKI",
    "VELOS",
    "ROCKYARD",
    "REALMO",
    "ZORROMOP",
    "ZEPITOPE",
    "COLAIRE",
    "OVOLO",
    "ZAJ",
    "PATHWAYS",
    "ILLUMITY",
    "JASPER",
    "VIXO",
    "GLASSTEP",
    "CORIANDER",
    "ENAUT",
    "QUIZMO",
    "ISOLOGIA",
    "CYTREX",
    "TRIPSCH",
    "SQUISH",
    "HYDROCOM",
    "CUIZINE",
    "ZIORE",
    "DATAGENE",
    "DRAGBOT",
    "CIPROMOX",
    "IMPERIUM",
    "EXOZENT",
];

const RANDOM_NAME = [
    "Sue Roth",
    "Anderson Durham",
    "Concepcion Benton",
    "Love Hunter",
    "Mooney Finch",
    "Marissa Richmond",
    "Lourdes Dawson",
    "Rhodes Rush",
    "Jacobs Spears",
    "Marylou Mckinney",
    "Randall Duffy",
    "Morris Chandler",
    "Celina Castro",
    "Charlene Reynolds",
    "Kaufman Gilliam",
    "Malinda Pace",
    "Glenn Burt",
    "Nadia Blankenship",
    "Benton Jensen",
    "Blanche Miller",
    "Sykes Lynn",
    "Cantrell Watson",
    "Tillman Burnett",
    "Roxie Rivas",
    "Ernestine Cochran",
    "Alexis Wilkins",
    "Henderson Hudson",
    "Amanda Whitney",
    "Claudine Ellison",
    "Russell Harris",
    "Jolene Hampton",
    "Kate Rivera",
    "Leigh Wilkinson",
    "Imogene Meadows",
    "Barrett Adams",
    "Elisabeth Wooten",
    "Lakisha Woodard",
    "Reeves Craft",
    "Esther Mcintosh",
    "Mason Eaton",
    "Chambers Warner",
    "Austin Parker",
    "Elena Talley",
    "Hood Frye",
    "Maricela Cook",
    "Mcmillan Petersen",
    "Maureen Mitchell",
    "Reva Farrell",
    "Bullock Buckner",
    "Myers Fulton",
    "Gould Thomas",
    "Kaye Summers",
    "Parsons Townsend",
    "Stephanie Gordon",
    "England Watts",
    "Watson Bowers",
    "Barker Webb",
    "Shields Nash",
    "Sally Parks",
    "Mccall Bonner",
    "Abby Osborn",
    "Abigail Wheeler",
    "Luna Horn",
    "Alejandra Beach",
    "Collier Flowers",
    "Gomez Mccullough",
    "Selma Morin",
    "Camacho Velez",
    "Riddle Gay",
    "Coleen Oneil",
    "Oneill Larsen",
    "Desiree Wolf",
    "Norman Sanders",
    "Carmella Harmon",
    "Mercado Mcclain",
    "Hurley Mueller",
    "Robbie Travis",
    "Sadie Atkinson",
    "Hammond Fitzpatrick",
    "Landry Dodson",
    "Ford Lang",
    "Rose Oliver",
    "Lacey Mcbride",
    "James Fox",
    "Melinda Guerra",
    "Wallace Raymond",
    "Cynthia Jacobson",
    "Bridget Hayes",
    "White Leach",
    "Pierce Haley",
    "Roman Harvey",
    "Zelma Barr",
    "Giles Merrill",
    "Hayden Shaw",
    "Rosalinda Prince",
    "Bond Miles",
    "Sheryl Valencia",
    "Thomas Peck",
    "Heath Nelson",
    "Abbott Boyd",
];

const RANDOM_ADDRESS = [
    "929 King Street, Dexter, Rhode Island, 3203",
    "555 Sunnyside Court, Whitestone, Florida, 7499",
    "554 Havens Place, Malott, Wisconsin, 7120",
    "269 Graham Avenue, Dola, Marshall Islands, 6402",
    "708 Woodbine Street, Kingstowne, Maine, 3420",
    "306 Monument Walk, Hinsdale, Louisiana, 5424",
    "533 Monaco Place, Lumberton, New Mexico, 295",
    "601 Wallabout Street, Knowlton, Delaware, 1926",
    "135 Radde Place, Coaldale, California, 3865",
    "524 Stone Avenue, Summerfield, New York, 5903",
    "799 Bartlett Street, Nettie, Vermont, 2176",
    "412 Tehama Street, Rote, Alaska, 7334",
    "303 Bijou Avenue, Wintersburg, Maryland, 7248",
    "599 Cambridge Place, Tyro, Utah, 4656",
    "992 Jackson Street, Levant, Connecticut, 9960",
    "922 Lois Avenue, Watrous, Nevada, 4830",
    "446 Engert Avenue, Day, Illinois, 9537",
    "645 Lee Avenue, Chamberino, Washington, 9145",
    "422 Diamond Street, Aberdeen, West Virginia, 2695",
    "519 Boerum Place, Fairforest, Colorado, 2204",
    "596 Harbor Lane, Gordon, Kentucky, 3162",
    "236 McKibben Street, Kraemer, District Of Columbia, 7760",
    "913 Frank Court, Brownsville, Montana, 4871",
    "168 Milton Street, Ballico, Michigan, 4653",
    "252 Seeley Street, Belleview, New Hampshire, 7173",
    "463 Barwell Terrace, Watchtower, Palau, 9871",
    "524 Doone Court, Stockwell, South Carolina, 6247",
    "504 Friel Place, Clarktown, Guam, 8687",
    "727 Lake Avenue, Villarreal, Georgia, 5360",
    "255 Clinton Avenue, Edgar, Pennsylvania, 6642",
    "373 Randolph Street, Enoree, Hawaii, 949",
    "388 Neptune Court, Richford, Puerto Rico, 7263",
    "892 Congress Street, Driftwood, Iowa, 8127",
    "885 Stillwell Place, Hollins, Federated States Of Micronesia, 6013",
    "777 Girard Street, Washington, North Dakota, 3274",
    "418 Hampton Place, Munjor, Arkansas, 7940",
    "858 Martense Street, Sisquoc, American Samoa, 4053",
    "616 Whitney Avenue, Marne, Northern Mariana Islands, 3439",
    "602 Poplar Street, Succasunna, Virgin Islands, 808",
    "635 Front Street, Glenshaw, Kansas, 4439",
    "329 Jardine Place, Wheaton, Tennessee, 4636",
    "354 Kermit Place, Mahtowa, North Carolina, 3855",
    "412 Murdock Court, Indio, Indiana, 3398",
    "691 Waldane Court, Spokane, Massachusetts, 136",
    "226 Bay Avenue, Hailesboro, New Jersey, 911",
    "829 Harman Street, Nelson, Oregon, 3534",
    "962 Anchorage Place, Islandia, Texas, 8117",
    "974 Chapel Street, Zarephath, Wyoming, 5605",
    "667 Ovington Court, Alleghenyville, Arizona, 9055",
    "326 Broadway , Denio, Ohio, 1615",
    "392 Hyman Court, Valmy, Idaho, 4954",
    "893 Alice Court, Rodman, Mississippi, 6297",
    "743 Nixon Court, Delwood, South Dakota, 1870",
    "758 Ridge Court, Unionville, Nebraska, 5611",
    "732 Quentin Road, Chapin, Minnesota, 2905",
    "105 Eckford Street, Teasdale, Alabama, 244",
    "868 Arlington Avenue, Wescosville, Oklahoma, 8354",
    "267 Rewe Street, Homeland, Missouri, 7448",
    "719 Amity Street, Healy, Rhode Island, 5930",
    "643 Danforth Street, Ahwahnee, Florida, 7764",
    "252 Bethel Loop, Leming, Wisconsin, 2999",
    "963 Fenimore Street, Barstow, Marshall Islands, 5289",
    "421 Brooklyn Road, Venice, Maine, 6915",
    "384 Buffalo Avenue, Boomer, Louisiana, 888",
    "581 Hausman Street, Bangor, New Mexico, 2530",
    "809 Ash Street, Lynn, Delaware, 3926",
    "685 Vermont Street, Thatcher, California, 575",
    "183 Holt Court, Caledonia, New York, 2948",
    "782 Ryder Avenue, Umapine, Vermont, 7276",
    "143 Vermont Court, Nadine, Alaska, 818",
    "254 Desmond Court, Jamestown, Maryland, 2343",
    "340 Euclid Avenue, Bentley, Utah, 1865",
    "997 Evergreen Avenue, Mammoth, Connecticut, 5003",
    "144 Seacoast Terrace, Sanford, Nevada, 1647",
    "143 Kathleen Court, Snyderville, Illinois, 631",
    "220 Prescott Place, Layhill, Washington, 303",
    "442 Oriental Boulevard, Yorklyn, West Virginia, 6613",
    "711 Campus Place, Cedarville, Colorado, 567",
    "679 Holmes Lane, Waiohinu, Kentucky, 5435",
    "419 Lloyd Street, Gibbsville, District Of Columbia, 8180",
    "322 Poplar Avenue, Vincent, Montana, 3669",
    "240 Benson Avenue, Corriganville, Michigan, 8337",
    "790 Fillmore Avenue, Tuttle, New Hampshire, 2084",
    "612 Polar Street, Oley, Palau, 6030",
    "407 Cyrus Avenue, Montura, South Carolina, 4553",
    "393 Norfolk Street, Coleville, Guam, 3195",
    "387 Aurelia Court, Brandywine, Georgia, 8391",
    "300 Fuller Place, Strong, Pennsylvania, 4953",
    "570 Krier Place, Savannah, Hawaii, 2698",
    "810 Nichols Avenue, Trinway, Puerto Rico, 4304",
    "724 Hornell Loop, Delco, Iowa, 7527",
    "517 Morton Street, Bendon, Federated States Of Micronesia, 3873",
    "433 Suydam Place, Frank, North Dakota, 1336",
    "342 Gelston Avenue, Topaz, Arkansas, 7030",
    "997 Kaufman Place, Manchester, American Samoa, 3264",
    "332 Columbia Street, Sunriver, Northern Mariana Islands, 8796",
    "377 Will Place, Foscoe, Virgin Islands, 5578",
    "161 Lincoln Avenue, Wauhillau, Kansas, 9685",
    "544 Garfield Place, Norfolk, Tennessee, 4753",
    "477 Union Street, Thynedale, North Carolina, 7686",
];